<template>
  <v-container class="app-max-width">
    <v-alert v-if="timeReached" class="text-center">{{ $t('general.timer.time_reached') }}</v-alert>
    <v-row v-if="hasAnyHeaderContent" :class="{'content-covered':timeReached}">
      <v-col class="align-center">
        <h3 v-if="question.header_textassetid">{{$ta(question.header_textassetid)}}</h3>
        <question-item v-if="question.item_textassetid" :item="$ta(question.item_textassetid)"></question-item>
        <small v-if="question.subtitle_textassetid">{{$ta(question.subtitle_textassetid)}}</small>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" :class="{'content-covered':timeReached}">
        <QuestionContentRenderer :question="question"></QuestionContentRenderer>
      </v-col>
      <v-col cols="6" :class="{'content-covered':timeReached}">
        <QuestionresponseRenderer :journeyresponse="journeyresponse" @next="next()" @complete="emitComplete($event)" @time-reached="timeReached=true"></QuestionresponseRenderer>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import questionLayoutMixin from "./questionLayoutMixin";
import QuestionItem from "../elements/QuestionItem";
import applicationEventHub from "../../../../events/applicationEventHub";
export default {
  name: "HorizontalQuestionLayout",
  mixins:[questionLayoutMixin],
  components:{QuestionItem},
  computed:{
    hasAnyHeaderContent(){
      return this.question && (this.question.header_textassetid || this.question.subtitle_textassetid);
    }
  },
  data(){
    return {
      timeReached : false
    }
  },
  created(){
    applicationEventHub.$on('framework.back',this.back);
    applicationEventHub.$on('framework.next',this.next);
  },
  beforeDestroy(){
    applicationEventHub.$off('framework.back',this.back);
    applicationEventHub.$off('framework.next',this.next);
  }
}
</script>

<style scoped>
.align-center{
  text-align: center;
}
</style>